import React from 'react';

import { FormControl, Input } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, Typography, withTypography } from 'components/ui';
import type { BoxProps, TypographyProps } from 'components/ui';
import { useIsDesktopLargeBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  contentHeader: {
    marginHorizontal: 'auto' as never,
    marginVertical: spacing.$3,
  },
  inputWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
});

export const ContentHeader = ({ style, ...props }: TypographyProps) => {
  const isDesktopLarge = useIsDesktopLargeBreakpoint();

  return (
    <Typography
      {...props}
      variant="headerOne"
      fontSize={isDesktopLarge ? 30 : undefined}
      lineHeight={isDesktopLarge ? 36 : undefined}
      style={[styles.contentHeader, style]}
    />
  );
};

export const StyledInput = Input.withConfig({
  marginRight: '$2',
  flex: 1,
});

export const StyledFormControl = FormControl.withConfig({
  flexDir: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
});

export const ErrorLabel = withTypography({
  color: getDesignToken('color-error'),
  fontSize: 'xs',
});

export const InputWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.inputWrapper, style] });
